/**
 * Main
 *
 * Copyright (c) 2020 Aperia Company
 * Released under the MIT license
 */
//  export js
"use strict";

window.app = app;
$(function () {
  new app.Core();
  new app.Sticky();
  new app.Menu();
  new app.Custom();
  new app.IntersectElements();
  // new app.Video(".youtube-view");
  new app.YoutubeEmbedPlayer();
  new app.NavChange();
  new app.Slider({
    el: "#main-slider",
    options: {
      arrows: false,
      fade: true,
      autoplay: true,
      infinite: true,
      pauseOnHover: true
    }
  });
  new app.Slider({
    el: "#project-mv-slider",
    options: {
      arrows: true,
      dots: false,
      fade: true,
      autoplay: false,
      infinite: true
    }
  });

  new app.Slider({
    el: "#partner-slider",
    options: {
      slidesToShow: 4,
      slidesToScroll: 4,
      rows: 1,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            rows: 2
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#project-slider",
    options: {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#project-slider-our",
    options: {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#project-single-slider",
    options: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true
    }
  });

  new app.SliderThumbnail({
    elParent: "#history-single-slider",
    elChild: "#history-slider-thumb",
    optionParent: {
      arrows: false,
      infinite: true,
      autoplay: true
    },
    optionChild: {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      centerMode: true,
      prevArrow:
        '<button type="button" class="slide-prev"><i class="bi-chevron-left"></i></button>',
      nextArrow:
        '<button type="button" class="slide-next"><i class="bi-chevron-right"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#customer-slider",
    options: {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
  new app.SliderThumbnail({
    elParent: ".product-single-slider",
    elChild: ".product-single-thumb",
    optionParent: {
      arrows: true
    },
    optionChild: {
      slidesToShow: 3,
      slidesToScroll: 1
    }
  });

  new app.Slider({
    el: "#news-slider",
    options: {
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: false,
      arrows: false,
      centerMode: true,
      autoplay: false,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#news-detail-slider",
    options: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      centerMode: true,
      autoplay: false
    }
  });
  new app.Slider({
    el: "#author-slider",
    options: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true
    }
  });
});
